<template>
  <file-pond
    name="pond"
    ref="pond"
    class="logo-pond"
    className="logo-pond-panel"
    :allowImagePreview="true"
    imagePreviewMaxHeight="100"
    accepted-file-types="image/jpeg, image/png, image/webp"
    labelFileTypeNotAllowed="Tipo de archivo inválido"
    fileValidateTypeLabelExpectedTypes="Se espera {allButLastType} ó {lastType}"
    max-files="1"
    instant-upload="false"
    allowProcess="false"
    credits=""
    label-idle="Logo..."
    labelFileLoading="Cargando"
    labelFileLoadError="Error al cargar"
    labelFileProcessing="Subiendo"
    labelFileProcessingError="Error al subir el logo"
    labelTapToCancel="Presiona para cancelar"
    :maxFileSize="PesoMaximo"
    labelMaxFileSizeExceeded="El logo es muy pesado"
    labelMaxFileSize="El tamaño máximo es {filesize}"
    v-on:addfile="agregado"
    v-on:removefile="eliminado"
  />
</template>
<script>
import { environment } from "../../environments/environment";

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

import { EstadoLogo as Estado } from "../../data/enums";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

export default {
  components: {
    FilePond,
  },
  props: {
    pesoMaximo: String,
  },
  data() {
    return {
      /**Usado para saber si hay que guardar el logo */
      estado: Estado.vacio,
    };
  },
  computed: {
    PesoMaximo() {
      return this.pesoMaximo ?? environment.LOGO_PESO_MAXIMO;
    },
  },
  methods: {
    // Los eventos son llamados desde afuera del componente
    EventoCargarURL(url) {
      this.cargarURL(url);
    },
    EventoLimpiar() {
      this.limpiar();
    },
    // Cuando se agrega una imagen
    agregado(error) {
      if (!error) {
        // Cuando el estado es original es porque se triggereo este método
        // al agregar el logo original, por lo tanto no se debe hacer nada
        if (this.estado != Estado.original) {
          this.estado = Estado.nuevo;
          this.$emit("agregado", this.getArchivo());
        }
      } else console.error("Error al agregar logo");
    },
    cargarURL(url) {
      // El orden importa, realizar esto antes de cargar la url
      this.estado = Estado.original;
      this.$refs.pond.addFile(url);
    },
    // Cuando se elimina una imagen
    eliminado() {
      this.estado = Estado.vacio;
      this.$emit("eliminado");
    },
    getArchivo() {
      if (this.$refs.pond.getFile()) {
        return this.$refs.pond.getFile().file;
      }
      return null;
    },
    limpiar() {
      this.$refs.pond.removeFiles();
      this.estado = Estado.vacio;
    },
  },
};
</script>
<style>
.logo-pond-panel {
  margin: 0;
}
</style>
<style scoped>
.filepond--root {
  max-height: 1em;
}
</style>